import { toothRefToLabel } from '@principle-theorem/principle-core';
import {
  type IPerioRecord,
  type IPerioTableCell,
} from '@principle-theorem/principle-core/interfaces';
import { cloneDeep, set } from 'lodash';

export function upsertPerioValues(
  records: IPerioRecord[],
  events: IPerioTableCell[]
): IPerioRecord[] {
  const recordsByTooth = new Map<string, IPerioRecord>(
    records.map((record) => [toothRefToLabel(record.toothRef), record])
  );

  events.forEach((event) => {
    const toothKey = toothRefToLabel(event.metadata.toothRef);
    const oldData = { ...recordsByTooth.get(toothKey)?.data };

    recordsByTooth.set(toothKey, {
      toothRef: event.metadata.toothRef,
      data: set(cloneDeep(oldData), event.metadata.dataPath, event.value),
    });
  });

  return Array.from(recordsByTooth.values());
}
